import React, { useCallback, useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Link from '../components/Link';
import PageTitle from '../components/PageTitle';
import styles from './styles/Pedidos.module.css';

const filtrosIniciais = {
  id: '',
  dataInicio: '',
  dataFim: '',
  usuario: '',
  tipoPedido: '',
  status: 'ABERTO',
  estoqueAlvo: '',
  codigoProduto: '',
};

const STATUS_OPTIONS = ['ABERTO', 'EM SEPARAÇÃO', 'FINALIZADO', 'CANCELADO'];

const formatarData = (data) => {
  if (!data) return '-';
  return new Date(data).toLocaleDateString('pt-BR');
};

const obterClasseStatus = (status) => {
  if (status === 'FINALIZADO') return styles.statusFinalizado;
  if (status === 'CANCELADO') return styles.statusCancelado;
  if (status === 'EM SEPARAÇÃO') return styles.statusSeparacao;
  return styles.statusAberto;
};

const obterClasseEstoqueAlvo = (estoqueAlvo) => {
  const empresa = Number(estoqueAlvo);

  if (empresa === 10) return styles.estoqueAlvoEmpresa10;
  if (empresa === 20) return styles.estoqueAlvoEmpresa20;
  return styles.estoqueAlvoPadrao;
};

function Pedidos() {
  const navigate = useNavigate();
  const token = localStorage.getItem('token');

  const usuarioLogado = localStorage.getItem('usuario');
  const idUsuarioLogado = localStorage.getItem('usuarioId');
  const permissoes = JSON.parse(localStorage.getItem('permissoes') || '{}');
  const somentePedidosProprios = permissoes?.pedidos?.somente_pedidos_proprios === true || permissoes?.pedidos?.somente_pedidos_proprios === 'true';
  const usuariosFiltroPermitidos = Array.isArray(permissoes?.pedidos?.usuarios_filtro)
    ? permissoes.pedidos.usuarios_filtro.map(Number).filter(Number.isInteger)
    : [];
  const usuariosFiltroParam = usuariosFiltroPermitidos.join(',');
  const valorFiltroUsuarioProprio = String(idUsuarioLogado || usuarioLogado || '');
  const filtrosPadrao = useMemo(() => ({
    ...filtrosIniciais,
    usuario: somentePedidosProprios ? valorFiltroUsuarioProprio : '',
  }), [somentePedidosProprios, valorFiltroUsuarioProprio]);

  const [pedidos, setPedidos] = useState([]);
  const [usuariosFiltro, setUsuariosFiltro] = useState([]);
  const [estoquesAlvoFiltro, setEstoquesAlvoFiltro] = useState([]);
  const [filtros, setFiltros] = useState(filtrosPadrao);
  const [carregando, setCarregando] = useState(false);
  const [erro, setErro] = useState('');

  const buscarPedidos = useCallback(async () => {
    setCarregando(true);
    setErro('');

    try {
      const { data } = await axios.get('https://provin.ind.br/api/pedidos', {
        headers: { Authorization: `Bearer ${token}` },
        params: {
          ...filtros,
          usuariosFiltro: somentePedidosProprios ? undefined : usuariosFiltroParam || undefined,
        },
      });

      setPedidos(data);
    } catch (error) {
      console.error('Erro ao buscar pedidos:', error);
      setErro('Erro ao buscar pedidos.');
    } finally {
      setCarregando(false);
    }
  }, [filtros, somentePedidosProprios, token, usuariosFiltroParam]);

  useEffect(() => {
    buscarPedidos();
  }, [buscarPedidos]);

  useEffect(() => {
    if (!somentePedidosProprios) return;

    setFiltros((prev) => ({
      ...prev,
      usuario: valorFiltroUsuarioProprio,
    }));
  }, [somentePedidosProprios, valorFiltroUsuarioProprio]);

  useEffect(() => {
    const buscarUsuariosFiltro = async () => {
      try {
        const [usuariosResponse, estoquesAlvoResponse] = await Promise.all([
          axios.get('https://provin.ind.br/api/pedidos/filtros/usuarios', {
            headers: { Authorization: `Bearer ${token}` },
            params: { usuariosFiltro: usuariosFiltroParam || undefined },
          }),
          axios.get('https://provin.ind.br/api/pedidos/filtros/estoques-alvo', {
            headers: { Authorization: `Bearer ${token}` },
          }),
        ]);

        setUsuariosFiltro(usuariosResponse.data);
        setEstoquesAlvoFiltro(estoquesAlvoResponse.data);
      } catch (error) {
        console.error('Erro ao buscar opções dos filtros:', error);
      }
    };

    buscarUsuariosFiltro();
  }, [token, usuariosFiltroParam]);

  const alterarFiltro = (campo, valor) => {
    if (campo === 'usuario' && somentePedidosProprios) {
      return;
    }

    setFiltros((prev) => ({
      ...prev,
      [campo]: valor,
    }));
  };

  const limparFiltros = () => {
    setFiltros(filtrosPadrao);
  };

  return (
    <div className={styles.body}>
      <Header />

      <main className={styles.pageShell}>
        <Link redirectTo="/home" />
        <PageTitle src="/images/common/pedidos.ico" title="Pedidos" />

        <section className={styles.filtrosCard}>
          <div className={styles.filtrosHeader}>
            <div>
              <h2>Gerenciamento de pedidos</h2>
              <p>{pedidos.length} {pedidos.length === 1 ? 'pedido encontrado' : 'pedidos encontrados'}</p>
            </div>

            <button type="button" onClick={limparFiltros} className={styles.botaoSecundario}>
              Limpar filtros
            </button>
          </div>

          <div className={styles.filtrosGrid}>
            <label>
              ID
              <input
                type="number"
                min="1"
                value={filtros.id}
                onChange={(e) => alterarFiltro('id', e.target.value)}
                placeholder="Ex.: 1024"
              />
            </label>

            <label>
              Código produto
              <input
                type="text"
                value={filtros.codigoProduto}
                onChange={(e) => alterarFiltro('codigoProduto', e.target.value)}
                placeholder="Ex.: 1001, 1002"
              />
            </label>

            <label>
              Período
              <input
                type="date"
                value={filtros.dataInicio}
                onChange={(e) => alterarFiltro('dataInicio', e.target.value)}
              />
            </label>

            <label>
              &nbsp;
              <input
                type="date"
                value={filtros.dataFim}
                onChange={(e) => alterarFiltro('dataFim', e.target.value)}
              />
            </label>

            <label>
              Usuário
              <select
                value={filtros.usuario}
                onChange={(e) => alterarFiltro('usuario', e.target.value)}
                disabled={somentePedidosProprios}
              >
                {somentePedidosProprios ? (
                  <option value={valorFiltroUsuarioProprio}>{usuarioLogado || 'Meu usuário'}</option>
                ) : (
                  <>
                    <option value="">Todos</option>
                    {usuariosFiltro.map((usuario) => (
                      <option key={usuario.id} value={usuario.id}>
                        {usuario.usuario}
                      </option>
                    ))}
                  </>
                )}
              </select>
            </label>

            {/* <label>
              Tipo pedido
              <select
                value={filtros.tipoPedido}
                onChange={(e) => alterarFiltro('tipoPedido', e.target.value)}
              >
                <option value="">Todos</option>
                <option value="sacola">Sacola</option>
              </select>
            </label> */}

            <label>
              Status
              <select
                value={filtros.status}
                onChange={(e) => alterarFiltro('status', e.target.value)}
              >
                <option value="">Todos</option>
                {STATUS_OPTIONS.map((status) => (
                  <option key={status} value={status}>{status}</option>
                ))}
              </select>
            </label>

            <label>
              Estoque alvo
              <select
                value={filtros.estoqueAlvo}
                onChange={(e) => alterarFiltro('estoqueAlvo', e.target.value)}
              >
                <option value="">Todos</option>
                {estoquesAlvoFiltro.map((estoque) => (
                  <option key={estoque.estoque_alvo} value={estoque.estoque_alvo}>
                    Empresa {estoque.estoque_alvo}
                  </option>
                ))}
              </select>
            </label>
          </div>
        </section>

        {erro && <p className={styles.mensagemErro}>{erro}</p>}

        <section className={styles.tabelaCard}>
          <div className={styles.tabelaScroll}>
            <table className={styles.tabela}>
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Estoque alvo</th>
                  <th>Data</th>
                  <th>Usuário</th>
                  <th>Status</th>
                  <th>Itens</th>
                  <th>Qtd.</th>
                  <th>Separação</th>
                  <th>Observações</th>
                </tr>
              </thead>
              <tbody>
                {carregando ? (
                  <tr>
                    <td colSpan="9" className={styles.estadoTabela}>Carregando pedidos...</td>
                  </tr>
                ) : pedidos.length === 0 ? (
                  <tr>
                    <td colSpan="9" className={styles.estadoTabela}>Nenhum pedido encontrado.</td>
                  </tr>
                ) : (
                  pedidos.map((pedido) => {
                    const percentual = pedido.total_itens > 0
                      ? Math.round((pedido.itens_separados / pedido.total_itens) * 100)
                      : 0;

                    return (
                      <tr
                        key={pedido.id}
                        onClick={() => navigate(`/pedidos/${pedido.id}`)}
                        className={styles.linhaClicavel}
                      >
                        <td><strong>#{pedido.id}</strong></td>
                        <td>
                          {pedido.estoque_alvo ? (
                            <span className={`${styles.estoqueAlvoBadge} ${obterClasseEstoqueAlvo(pedido.estoque_alvo)}`}>
                              Empresa {pedido.estoque_alvo}
                            </span>
                          ) : '-'}
                        </td>
                        <td>{formatarData(pedido.dt_criacao)}</td>
                        <td>{pedido.usuario}</td>
                        <td>
                          <span className={`${styles.statusBadge} ${obterClasseStatus(pedido.status)}`}>
                            {pedido.status || '-'}
                          </span>
                        </td>
                        <td>{pedido.total_itens}</td>
                        <td>{pedido.total_qtd}</td>
                        <td>
                          <div className={styles.progressoSeparacao}>
                            <span>{pedido.itens_separados}/{pedido.total_itens}</span>
                            <div>
                              <i style={{ width: `${percentual}%` }} />
                            </div>
                          </div>
                        </td>
                        <td>{pedido.observacoes || '-'}</td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>
        </section>
      </main>
    </div>
  );
}

export default Pedidos;
